import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { cargoService, Cargo } from '../../services/cargo';

interface SelectCargoProps {
  value?: number;
  onChange: (value: number) => void;
  label?: string;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  fullWidth?: boolean;
}

const SelectCargo: React.FC<SelectCargoProps> = ({
  value,
  onChange,
  label = 'Cargo',
  required = false,
  error = false,
  helperText,
  disabled = false,
  fullWidth = true,
}) => {
  const { data: cargos = [], isLoading } = useQuery({
    queryKey: ['cargos'],
    queryFn: cargoService.getAll,
  });

  const handleChange = (event: any) => {
    onChange(Number(event.target.value));
  };

  return (
    <FormControl fullWidth={fullWidth} required={required} error={error} disabled={disabled}>
      <InputLabel id="cargo-label">{label}</InputLabel>
      <Select
        labelId="cargo-label"
        value={value || ''}
        onChange={handleChange}
        label={label}
        disabled={isLoading || disabled}
      >
        {cargos.map((cargo) => (
          <MenuItem key={cargo.id} value={cargo.id}>
            {cargo.descricao}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default SelectCargo;
